module.exports = __webpack_public_path__ + "static/img/m2_2.3ddb007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/medication/m2_2.png
// module id = MCKi
// module chunks = 1